import { useState } from "react";
import { Link, useParams } from "react-router-dom";
import { useDeleteData } from "../Hooks/useDeleteData";
import Email from "../Icons/Email";
import ViewIcon from "../Icons/ViewIcon";
import { FaCheckCircle, FaClipboardCheck, FaEye, FaHourglassHalf, FaRegFileAlt, FaRegThumbsUp, FaTimesCircle } from "react-icons/fa";
import { GetAccess, GetRole } from "./roles";
import EditIcon from "../Icons/Edit";
import DeleteIcon from "../Icons/Delete";
import Chat from "../Icons/Chat";
import ModalContainer from "../Others/ModalContainer";
import { Modal, Tooltip } from "antd";
import EditEmailSent from "../../Views/Web/E-Mail/EmailSent/EditEmailSent";
import ViewEmailSent from "../../Views/Web/E-Mail/EmailSent/ViewEmailSent";
import EditEquipments from "../../Views/Web/Settings/Equipments/EditEquipments";
import ViewEquipments from "../../Views/Web/Settings/Equipments/ViewEquipments";
import EmailModal from "./EmailModel";
import ModalEmail from "../Others/ModalForEmail";
import { useContacts } from "../../Views/Web/Client Management/Contracts/ContractsContext";
import { useClients } from "../../Views/Web/Client Management/Clients/ClientContext";



const MoreOptions = ({
    data,
    fetcher,
    id,
    removevalue,
    url,
    eUrl,
    moduleName,
    from,
    viewLink,
    editLink,
    EmailRequired,
    isApprovalDone,
    isEmailSent,
    EditAccess = "",
    DeteleAccess = "",
    emailType,
    adminPermmision,
    curentPage,
    searchQuery,
    name="",
  }) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [modalOpen, setModalOpen] = useState(false);
    const {updateInspection,updateEquipments,updateInvoice,updateService} = useContacts()
    const {updateClientInspection,updateClientEquipments,updateClientService,updateClientInvoice,updateClientContaract}=useClients()
    const { handle } = useDeleteData(fetcher);
    const handleDelete = async () => handle(url + `${id}`, setIsModalOpen);
    let Edit = editLink ? true : null;
    let Comment = editLink ? false : null;
  
    let EditCondition = editLink?.includes("{id}") ? true : false;
    let editableLink = EditCondition ? editLink.replace("{id}", `${id}`) : "";
  
    let Delete = true;
    
  
    const getStatusIcon = () => {
      const status = data?.approvalStatus?.toLowerCase();
    
      switch (status) {
        case "approved":
        case "approval":
          return (
            <Tooltip title={<p className="text-[11px]">Approved</p>} color="#22c55e">
              <FaCheckCircle className="text-green-500" />
            </Tooltip>
          );
    
        case "pending":
          return (
            <Tooltip title={<p className="text-[11px]">Pending</p>} color="#eab308">
              <FaHourglassHalf className="text-yellow-500" />
            </Tooltip>
          );
    
        case "rejected":
        case "declined":
        case "decline":
          return (
            <Tooltip
              title={<p className="text-[11px]">{status.charAt(0).toUpperCase() + status.slice(1)}</p>}
              color="#ef4444"
            >
              <FaTimesCircle className="text-red-500" />
            </Tooltip>
          );
    
        case "verified":
        case "verify":
          return (
            <Tooltip title={<p className="text-[11px]">Verified</p>} color="#a855f7">
              <FaClipboardCheck className="text-purple-500" />
            </Tooltip>
          );
    
        case "reviewed":
        case "review":
          return (
            <Tooltip title={<p className="text-[11px]">Reviewed</p>} color="#6366f1">
              <FaRegFileAlt className="text-indigo-500" />
            </Tooltip>
          );
    
        default:
          return null;
      }
    };
    

    const [isViewModalOpen, setIsViewModalOpen] = useState(false); // View modal state
    const [isEditModalOpen, setIsEditModalOpen] = useState(false); // Edit modal state
  
    const openEditModal = () => {
      setIsEditModalOpen(true);
     
    };
  
    const openViewModal = () => {
      setIsViewModalOpen(true);
     
    };

    const [isViewModalOpenEmail, setIsViewModalOpenEmail] = useState(false); // View modal state
    const [isEditModalOpenEmail, setIsEditModalOpenEmail] = useState(false); // Edit modal state
  
    const openEditModalEmail = () => {
      setIsEditModalOpenEmail(true);
     
    };
  
    const openViewModalEmail = () => {
      setIsViewModalOpenEmail(true);
     
    };

    return (
      <>
        <div className=" w-full flex  justify-start items-center">
          <div className=" w-full flex justify-start ">
            
          {moduleName !== "Sales-Orders" && (
    <div className="w-[20%] overflow-hidden flex justify-center items-center">
      {getStatusIcon()}
    </div>
  )}
  
           {EmailRequired && !isEmailSent && isApprovalDone && (
             <div 
              className=" w-[25%] overflow-hidden flex justify-center items-center cursor-pointer "
              onClick={() => {
                setModalOpen(true);
              }}
            >
              <Email height={"13"} width={"13"} color="#BF2EF0" />
            </div>
         )}  

            {moduleName === "Equipments" && (
          <>
            {/* View Icon */}
            <div
              className="w-[25%] overflow-hidden flex justify-center items-center cursor-pointer"
              onClick={openViewModal}
            >
              <ViewIcon  color="#048178" />
            </div>

           
              <div
                className="w-[25%] overflow-hidden flex justify-center items-center cursor-pointer"
                onClick={openEditModal}
              >

                <EditIcon color="skyblue" width={"12"} height={"12"} />
              </div>
            
          </>
        )}   
          {moduleName === "Email" && (
          <>
            {/* View Icon */}
            <div
              className="w-[25%] overflow-hidden flex justify-center items-center cursor-pointer"
              onClick={openViewModalEmail}
            >
              <ViewIcon  color="#048178" />
            </div>

           
              {/* <div
                className="w-[25%] overflow-hidden flex justify-center items-center cursor-pointer"
                onClick={openEditModalEmail}
              >

                <EditIcon color="skyblue" width={"12"} height={"12"} />
              </div> */}
            
          </>
        )}   
         {(moduleName !== "Equipments" && moduleName !== 'Email' )&& (
           <> <div className=" w-[25%] overflow-hidden flex justify-center items-center">
              <Link
                className=" text-black hover:text-black border-none"
                to={viewLink + `${id}`}
                state={{ 
                  data: data,
                  pageIndex:curentPage,
                  searchQuery: searchQuery!==""?searchQuery:searchQuery
                 }}
                onClick={()=>{
                  if(name=="ContractsTable"){
            updateInspection(data["tabs"]?.inspection||false)
            updateEquipments(data["tabs"]?.equipments||false)
            updateService(data["tabs"]?.service||false)
            updateInvoice(data["tabs"]?.invoice||false)
          }else if(name =="ClientTable"){
          
            
            updateClientInspection(data["tabs"]?.inspection||false)
            updateClientEquipments(data["tabs"]?.equipments||false)
            updateClientService(data["tabs"]?.service||false)
            updateClientInvoice(data["tabs"]?.invoice||false)
            updateClientContaract(data["tabs"]?.contract||false)
          }
                }}
              >
                <ViewIcon color="#048178" />
              </Link>
            </div>
            {Edit && (
              <>
                {data?.approvalStatus?.toLowerCase() == "verified" ||
                data?.approvalStatus?.toLowerCase() == "approved" ? (
                  <>
                  {
                    moduleName.toLowerCase() == "purchase order"||moduleName.toLowerCase() == "ypr" ?
                    (
                      <>
                      {GetAccess(EditAccess) && (
                      <div className=" w-[25%] overflow-hidden flex justify-center items-center ">
                        <Link
                          className=" text-black hover:text-black border-none"
                          to={EditCondition ? editableLink : editLink + `${id}`}
                          state={{ data: data, from: from }}
                        >
                          <EditIcon color="skyblue" width={"12"} height={"12"} />
                        </Link>
                      </div>
                    )}
                      </>
                    ):(
                      <>
                    {GetRole() && (
                      <div className=" w-[25%] overflow-hidden flex justify-center items-center ">
                        <Link
                          className=" text-black hover:text-black border-none"
                          to={EditCondition ? editableLink : editLink + `${id}`}
                          state={{ data: data, from: from }}
                        >
                          <EditIcon color="skyblue" width={"12"} height={"12"} />
                        </Link>
                      </div>
                    )}
                      </>
                    )
                  }
                  </>
                ) : (
                  <>
                    {GetAccess(EditAccess) && (
                      <div className=" w-[25%] overflow-hidden flex justify-center items-center ">
                        <Link
                          className=" text-black hover:text-black border-none"
                          to={EditCondition ? editableLink : editLink + `${id}`}
                          state={{ data: data, from: from }}
                        >
                          <EditIcon color="skyblue" width={"12"} height={"12"} />
                        </Link>
                      </div>
                    )}
                  </>
                )}
              </>
            )}
  </>)}
            {/* {Delete && ( */}
              {/* <> */}
                {data?.approvalStatus?.toLowerCase() == "verified" ||
                data?.approvalStatus?.toLowerCase() == "approved" ? (
                  <>
                    {GetRole() && (
                      <div
                        className=" w-[25%] overflow-hidden flex justify-center items-center cursor-pointer "
                        onClick={() => {
                          setIsModalOpen(true);
                        }}
                      >
                        <DeleteIcon height={"13"} width={"13"} color="lightcoral" />
                      </div>
                    )}
                  </>
                ) : (
                  <>
                    {GetAccess(DeteleAccess) &&  moduleName !== "Mytasks" &&(
                      <div
                        className=" w-[25%] overflow-hidden flex justify-center items-center cursor-pointer "
                        onClick={() => {
                          setIsModalOpen(true);
                        }}
                      >
                        <DeleteIcon height={"13"} width={"13"} color="lightcoral" />
                      </div>
                    )} 
                  </>
                )}
              {/* </>
            )} */}
  
            {Comment && (
              <div className=" w-[25%] overflow-hidden flex justify-center items-center  cursor-pointer ">
                <Chat width={"11"} height={"11"} />
              </div>
            )}
          </div>
        </div>
        <ModalContainer
          visiable={isModalOpen}
          title="Warning"
          content={`Are you sure you want to remove ${removevalue} from ${moduleName}?`}
          handleClick={() => handleDelete()}
          closeModal={() => setIsModalOpen(false)}
        />

{isEditModalOpen&&(
       <EditEquipments
        open={isEditModalOpen}
        data={data}
        onCancel={() => setIsEditModalOpen(false)}
        getData={fetcher}
        firstProject={id}       
      />
    )}

          {isViewModalOpen && (       
        <Modal
        open={isViewModalOpen}
        onCancel={()=>setIsViewModalOpen(false)}
        title={""}
        width="50%"
        centered
           className="my-modal"
     
        footer={[]}
      >
        {/* <ViewActivity/> */}
        <ViewEquipments data={data} open={isViewModalOpen} onCancel={() => setIsViewModalOpen(false)} />
      </Modal>
      )}
      {isEditModalOpenEmail&&(
       <EditEmailSent
        open={isEditModalOpenEmail}
        data={data}
        onCancel={() => setIsEditModalOpenEmail(false)}
        getData={fetcher}
        firstProject={id}       
      />
    )}

          {isViewModalOpenEmail && (       
        <Modal
        open={isViewModalOpenEmail}
        onCancel={()=>setIsViewModalOpenEmail(false)}
        title={""}
        width="50%"
        centered
           className="my-modal"
     
        footer={[]}
      >
        {/* <ViewActivity/> */}
        <ViewEmailSent data={data} open={isViewModalOpenEmail} onCancel={() => setIsViewModalOpen(false)} />
      </Modal>
      )}

        <ModalEmail
        visiable={modalOpen}
        title="Send Email"
        hasContent={true}
        content={
          <>
            <EmailModal
              fetcher={fetcher}
              vendorId={data?.vendor || data?.vendorId}
              id={data?.id}
              eUrl={eUrl}
              idd={id}
              onClose={() => setModalOpen(false)}
              emailType={emailType}
            />
          </>
        }
        // handleClick={() => {}}
        hasButton={false}
        // outSideClick={false}
        closeModal={() => setModalOpen(false)}
      />
      </>
    );
  };
  export default MoreOptions;
